<template>
    <div>
        <h1 align="center">
            <strong><u>TERMS OF USE</u></strong>
        </h1>
        <p align="center">
            <strong><u></u></strong>
        </p>
        <p>
            Welcome to <strong>TravelQuest</strong>, these Terms of Use (hereinafter
            referred to as the <strong>“Terms”</strong>) shall govern the relationship
            between <strong>TravelQuest</strong>, having its registered office in<strong>Sderot Tsahal 4, Lod, Israel </strong>(hereinafter referred to the<strong>“Company”</strong> or <strong>“TravelQuest”</strong> or    <strong>“us”</strong> or <strong>“our”</strong> or <strong>“we”</strong>)
            and you (hereinafter referred to <strong>“you”</strong> or<strong>“your”</strong> or <strong>“user”</strong> or    <strong>“users” </strong>or<strong> “customers”</strong>) and shall also
            govern your use of TravelQuest.xyz and its related mobile applications,
            namely <strong>“TravelQuest”</strong> (hereinafter referred to as the<strong>“Website”</strong> or <strong>“Site” </strong>or    <strong>“App” </strong>or <strong>“Platform”</strong>).
        </p>
        <p>
            Please read these <strong>Terms</strong> carefully, as these, along with
            our <strong>Disclaimer,</strong> <strong>Privacy Policy</strong> statement
            and <strong>Cookie Policy</strong>, forms the entire agreement between you
            and TravelQuest. Additionally, if you are a creator on our platform, then
            our <strong>Creator Terms </strong>shall also apply to you. If you do not
            accept these Terms in its entirety, then you may not use the Platform, or
            avail services available on the Platform.
        </p>
        <p>
            This electronic record is generated by a computer system and does not
            require any physical or digital signatures.
        </p>
        <p>
            Additionally, how we collect, use, store, share and transmit your data is
            governed by our <strong>Privacy Policy</strong> statement and    <strong>Cookie Policy</strong>. These <strong>Terms of Use</strong> shall
            be read in conjunction with those documents. In case you are a Creator,
            please refer to <strong>Creator Terms</strong> as available on our Site and
            App.
        </p>
        <p>
            <strong>1. </strong>
            <strong>Acceptance of the Terms of Use</strong>
        </p>
        <p>
            By accessing or using or registering or creating a quest or purchasing
            tickets to quest or availing the services through our Platform in any way
            or by clicking on a button or taking similar action to signify your
            affirmative acceptance of these Terms, you hereby represent that:
        </p>
        <p>
            i. You have read, understood, and agreed to be bound by these Terms and any
            future updates and additions to these Terms, as published from time to time
            at the Website. Additionally, if you are a Creator, you have read and
            understood our <strong>Creator Terms</strong>.
        </p>
        <p>
            ii. You are of sound mind, competent to contract and are at least of the
            age of majority as per the laws of the jurisdiction in which you reside, in
            order to form a binding contract with us.
            <em>
                <u>
                    In case you are not of the age of majority, then you must have the
                    permission of your lawful guardian to use and access our Platform
                    in their strict supervision.
                </u>
            </em>
        </p>
        <p>
            iii. We must not have previously disabled your account for violation of law
            or any of our policies. Moreover, you shall not be prohibited as per the
            applicable law of the State in whose jurisdiction you reside, from
            accessing our services, or participating in any of the quests available on
            our Platform.
        </p>
        <p>
            iv. You agree, understand and acknowledge that the we are a marketplace for
            games/quests that are created by third party users on our platform (known
            as <strong>“Creators”</strong>), as such we are only a facilitator between
            you and such third-party Creators, and we cannot be a party to or control
            in any manner any transactions on the Platform, or your interaction with
            the Creators outside of the Platform.
            <strong>
                <u>
                    Accordingly, the contract of sale of service shall be a strictly
                    bipartite contract between you and the Creators.
                </u>
            </strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>2. </strong>
            <strong>Service</strong>
        </p>
        <p>
            On TravelQuest marketplace, we allow users to create, host and sell games
            created by other users of the service. Creators may sell their games using
            TQ Store and pay a service fee when a booking is confirmed. Games can be
            made up of various missions, which may include activities, including
            without limitation, submitting photos or videos, checking-in at specific
            locations, or solving puzzles or riddles in order to receive points. These
            games may be played with a closed user group and/or with the Internet
            community. (<strong>“Service”</strong>)
            <em>
                The Service may be accessed from a computer or a personal mobile. The
                level of functionality of the Service which you may have an access to,
                or use, may vary, depending upon your subscription to the Service, and
                different fees may be payable for different subscription types.
            </em>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>3. </strong>
            <strong>Accounts, Passwords and Security</strong>
        </p>
        <p>
            a) <strong>Account Registration: </strong>
            <strong>
                To access most parts of the Website, and to avail various services        <em>(such as to enter a quest or to purchase a ticket to one)</em>
            </strong>
            <strong>, </strong>
            <strong>
                you might be required to register and create an account with us, or
                avail our guest login facility, but with limited features and
                functionalities.
            </strong>
            When setting up and maintaining your account, you must provide and continue
            to provide accurate and complete information about yourself.
            <a href="https://www.lawinsider.com/clause/account-password-and-security">
                As part
            </a>
            of the registration process, you will create a username, password and an
            account.
        </p>
        <p>
            b) <strong>Social Media Signup:</strong> You also have an option of signing
            up using social media accounts, such as Google and Facebook. In case, you
            chose to sign up using any of the social media account, you will be
            re-directed to the website of such social media account, and therefore, in
            addition to these Terms and our Privacy Policy, you will also be subject to
            the terms and privacy policy of such social media website.
        </p>
        <p>
            c) <strong>Security:</strong> You are responsible for maintaining the
            confidentiality of the password and account, and are fully responsible for
            all activities that occur under your account, including, without
            limitation, all actions by sub-users registered under your account. You
            agree to (a) immediately notify us of any unauthorized use of your password
            or account or any other breach of security, and (b) ensure that you exit
            from your account at the end of each session. We cannot and will not be
            liable for any loss, damage or other liability arising from your failure to
            comply with this Section or from any unauthorized access to or use of your
            account.
        </p>
        <p>
            d) <strong>Inaccurate Information:</strong> If we have reasonable grounds
            to suspect that any of the information submitted by you is untrue,
            inaccurate, outdated, or incomplete, we may terminate your account, and
            refuse current or future use of any or all of the Services.
        </p>
        <p>
            <strong>4. </strong>
            <strong>Use of the Site</strong>
        </p>
        <p>
            <strong> i. </strong>
            <strong>Allowed uses:</strong>
        </p>
        <p>
            <a name="_Hlk69461058">
                <strong>a) </strong>
                <strong>App Updates: </strong>
            </a>
            From time to time, we will bring new updates to our App, mostly in order to
            enhance the user experience and/or to improve the safety and security of
            our users, or for any other reason as we deem fit at our sole discretion.
            You agree to update the App as and when such updates are ready and
            available. <strong></strong>
        </p>
        <p>
            b) <strong>Directions of Use:</strong> You must follow any and all
            guidelines or policies or directions of use as associated with each of the
            services on the site.
            <em>
                <u>
                    For instance, before entering a particular quest, you can be
                    required to agree to the terms of such quest.
                </u>
            </em>
        </p>
        <p>
            c) <strong>Information:</strong> Whenever prompted, you must provide us
            with the correct, accurate and updated information, including but not
            limited to your name, location, email, contact number etc.
        </p>
        <p>
            d) <strong>Material:</strong> For the purposes of these Terms, “material”
            shall mean any text, image, video, graphics and sound material, published
            on the Website, whether a copyright of TravelQuest, Creators, any user, our
            licensors or any third party. You are not allowed to download or print the
            material, or extracts from it, in a systematic or regular manner or
            otherwise so as to create a database in electronic or paper form comprising
            all or part of the material appearing on the Website. You must not
            reproduce any part of the Website or the material or transmit it to or
            store it in any other website or disseminate any part of the material in
            any other form, unless we have indicated that you may do so.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong> ii. </strong>
            <strong>Restricted uses:</strong>
        </p>
        <p>
            a) You cannot create multiple accounts, without our express permission.    <strong></strong>
        </p>
        <p>
            b) You can’t impersonate others or provide inaccurate information.    <strong></strong>
        </p>
        <p>
            c) You can’t raise or comment or write feedback on any political, racist or
            such other issue which effect’s a person, community or society.
        </p>
        <p>
            d) You shall not make any defamatory or denigrating statement(s) about
            TravelQuest, its Creators, or our brand name or domain name used by
            TravelQuest, or otherwise act in any manner that might tarnish the
            reputation or standing of TravelQuest or Creators or Users on the Platform
            or otherwise tarnish or dilute any of TravelQuest’s trademarks, service
            marks, trading name, or the goodwill associated with them.
        </p>
        <p>
            e) You must not misuse or interfere with the Services or Platform or try to
            access them using a method other than the interface and the instructions
            that we provide. You may use the Services only as permitted by law and as
            per the directions provided by us and the Creators. <strong></strong>
        </p>
        <p>
            f) You must not:<strong></strong>
        </p>
        <p>
            · republish material from this Website;<strong></strong>
        </p>
        <p>
            · sell, rent or sub-license material from the Website;<strong></strong>
        </p>
        <p>
            · show any material from the Website in public without our consent;    <strong></strong>
        </p>
        <p>
            · edit or otherwise modify any material on the Website (other than editing
            your own information as per the method provided);<strong></strong>
        </p>
        <p>
            · reproduce, duplicate, copy or otherwise exploit material on our Platform
            for a commercial purpose; or<strong></strong>
        </p>
        <p>
            · redistribute material from the Website, except for content specifically
            and expressly made available for redistribution with our written consent
            and according to our terms;<strong></strong>
        </p>
        <p>
            · infringe or violate our Intellectual Property Rights or Intellectual
            Property Rights of our licensors, Creators or any third party;    <strong></strong>
        </p>
        <p>
            · We reserve the right to restrict your access to any areas of our
            Platform, or indeed our whole Platform, at our discretion.<strong></strong>
        </p>
        <p>
            g) You must not use our Platform in any way that causes, or may cause,
            damage to the Platform or impairment of the availability or accessibility
            of the Platform; or in any way which is unsafe, unlawful, illegal, immoral,
            fraudulent or harmful, or in connection with any unlawful, illegal,
            fraudulent or harmful purpose or activity.<strong></strong>
        </p>
        <p>
            h) You must not use our Platform to copy, store, host, transmit, send, use,
            publish or distribute any material which consists of (or is linked to) any
            spyware, computer virus, trojan horse, worm, keystroke logger, rootkit or
            other malicious computer software.<strong></strong>
        </p>
        <p>
            i) You must not conduct any systematic or automated data collection
            activities (including without limitation scraping, data mining, data
            extraction and data harvesting) on or in relation to our Platform, without
            our express written consent.<strong></strong>
        </p>
        <p>
            j) You must not access our Platform strictly for the purpose of building a
            competitive product.<strong></strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            In case of your violation or non-compliance of any of the terms mentioned
            in this Terms of Use, we reserve the right to suspend or terminate your
            account or your access to the Platform or our services, at our sole
            discretion.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>5. </strong>
            <strong>Writing a Review or leaving a Feedback</strong>
        </p>
        <p>
            You may be able to rate the services you avail from the Platform, share
            your experience and provide a feedback or review for such services availed
            by you. In such case, you shall provide your honest and true feedback and
            opinion. You agree not to post anything or perform any act that is deemed
            to be abusive, derogatory, political, immoral, unlawful, inappropriate,
            objectionable, or that infringes on any third-party rights. We reserve the
            right to delete or not display your feedback, at our sole discretion.
        </p>
        <p>
            <strong>6. </strong>
            <strong>Ownership Rights<a name="_Hlk69461512"></a></strong>
        </p>
        <p>
            <strong>a) </strong>
            <strong>Our Rights</strong>
            : This Website, App, its trademark, trade name, logos, design, features,
            its content, quests and services listed on it shall remain the sole
            property of the TravelQuest or its Creators, as the case may be. Your use
            of or access to this Platform shall not in any way transfer or assign to
            you any ownership or other proprietary rights in or to this Website, App,
            or any content published by us or our licensors or third parties. This
            Website, App and the content, including but not limited to the trademark,
            logo, copyright, design, layout, typography, underlying HTML, Java scripts,
            text, audio clips, video clips and graphics, and in the expression of the
            information contained herein, whether as a compilation or otherwise is
            protected by relevant Intellectual Property laws, rules and regulations.
            Trademarks, trade names and designs appearing on this Website are the
            exclusive property of, or are licensed to the TravelQuest and are
            protected. No use of a trademark, trade dress, trade name or design
            appearing on this Website or App may be made without the prior written
            permission of TravelQuest.<strong></strong>
        </p>
        <p>
            <strong>b) </strong>
            <strong>Content submitted by user: </strong>
            You will have an option to submit various content, such as photos, videos,
            audio, etc. in the games that you play on our platform. As between you and
            the Creators, it is mostly the Creators who hold the intellectual property
            rights to such content of yours, as would be determined from their terms
            that you agree to before entering a specific game/quest.<strong></strong>
        </p>
        <p>
            <strong>c) </strong>
            <strong>License of user content:</strong>
            By submitting, posting or displaying any user content on or through the
            Service, you grant us (and our agents) a non-exclusive, royalty-free,
            world-wide, perpetual license <em>(with the right to sublicense)</em> to
            use, copy, modify, transmit, display and distribute such user content to
            the extent required to provide the Service. TravelQuest will not be
            responsible or liable for any use of user content in accordance with these
            Terms. You represent and warrant that you have all the rights, power and
            authority necessary to grant the rights granted herein to any user content
            that you submit.<strong></strong>
        </p>
        <p>
            <strong>7. </strong>
            <strong>Reservation of Right</strong>
        </p>
        <p>
            <em>a) </em>
            TravelQuest does not pre-screen any game, content or service or information
            listed or posted by the Creators or other users and TravelQuest is under no
            obligation to pre-screen any such content or information or validate the
            authenticity or genuineness of the information published or listed by the
            Creators. However, TravelQuest may at its discretion and/or in accordance
            with applicable law or on receipt of claim or order, may voluntarily take
            down any game or content or information posted by you, other user or
            Creators on the Platform and if TravelQuest determines that any game,
            content or information or listing is in violation of these Terms or our
            Creator Terms, TravelQuest may remove such content or listing or
            information from the Platform without notice.
            <em>
                <u>
                    Such actions do not in any manner negate or dilute TravelQuest’s
                    position as an intermediary or impose any liability on TravelQuest
                    with respect to games, content or listing or information published
                    or transmitted by users or Creators on the Platform.
                </u>
            </em>
        </p>
        <p>
            b) TravelQuest reserves the right to cooperate fully with governmental
            authorities, private investigators, injured third parties in the
            investigation of any suspected criminal or civil wrongdoing and/or any
            third parties alleging a claim against you. Further, TravelQuest may
            disclose the user's identity and contact information, if requested by any
            third party, government or law enforcement body, an injured third party, or
            as a result of a subpoena or other legal action.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>8. </strong>
            <strong>Privacy</strong>
        </p>
        <p>
            In order to see what data we collect and how we use or store or share such
            data, please refer to the detailed <strong>Privacy Policy</strong>
            statement available on our Website and App.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>9. </strong>
            <strong>iFrame and Links to Third-party Sites</strong>
        </p>
        <p>
            The Website uses iFrame and might also contain links to third-party
            websites, products and services.
            <em>
                For example, the Website works with third party payment service
                providers to provide you the most convenient payment options.
            </em>
            Such third-party links are not under the control of TravelQuest, and
            TravelQuest is not responsible for any third-party links. TravelQuest
            provides access to these third-party links only as a convenience to you,
            and does not review, approve, monitor, endorse, warrant, or make any
            representations with respect to third-party links. You shall use all
            third-party links at your own risk, and should apply a suitable level of
            caution and discretion in doing so. Whenever you click on such links, you
            are taken to such third-party website, and you get out of the jurisdiction
            of our Platform. Therefore, you shall be governed by the terms of use,
            privacy policy and other policies of such third-party websites and we
            suggest that you read those policies.
            <u>
                In case of any damage due to such action of third-party links,
                TravelQuest shall not be responsible.
            </u>
        </p>
        <p>
            <strong>10. </strong>
            <strong>Payments, Taxes and Refunds</strong>
        </p>
        <p>
            a) <strong>Entry Tickets: </strong>The entry ticket prices to each game or
            quest, is determined by the Creators of that specific game or quest. Some
            quests would be free for you to enter, while for the others, you would have
            to incur a cost.
        </p>
        <p>
            b) <strong>Payment:</strong> All paid tickets are subject to acceptance and
            availability and you agree to pay for such tickets after booking through
            the Platform, and you authorize us to charge your debit or credit card or
            process other means of payment for the same. You shall be responsible to
            borne all the applicable taxes and duties (wherever applicable), and other
            charges.
        </p>
        <p>
            c) <strong>No Responsibility</strong>: You further acknowledge that we
            shall not be responsible, in any manner whatsoever, for any loss incurred
            by you for a failed / incomplete transaction undertaken by you on the
            Platform.
        </p>
        <p>
            d) <strong>Refunds or Re-schedule</strong>: In case you cancel the ticket,
            within the period of first <strong>48 (forty-eight) hours</strong> after
            purchasing a quest, provided that you did not use the entry ticket, you
            shall be eligible for a full refund. Similarly, if a user procures a game
            entry ticket and the activity was not available, the user can request a
            full compensation. For this, you need to contact us at    <a href="mailto:dan@TravelAndQuest.com">dan@TravelAndQuest.com</a> We will
            process your refund, within a period of    <strong>7 (fifteen) business days</strong> and any refunds processed may
            take up to <strong>7 (seven) business days</strong> to reflect in your
            original method of payment. <a name="_Hlk73514926"></a>
        </p>
        <p>
            <strong>11. </strong>
            <strong>Fees and Charges</strong>
        </p>
        <p>
            We and our Creators reserve the right to modify the prices of our service,
            game or quest at any time, without any prior notice. However, if you have
            already purchased a ticket at a certain price, it will still hold good for
            you.
        </p>
        <p>
            <strong>12. </strong>
            <strong>Disclaimer</strong>
        </p>
        <p>
            We are an marketplace and an intermediary platform that connects Creators
            with the users. You acknowledge and undertake that you are accessing the
            services on the Platform and transacting at your own risk and are using
            your best and prudent judgment before entering into any transactions
            through the Platform. Please refer to our detailed    <strong>Declaimer statement</strong> as available on our website or App.
        </p>
        <p>
            <strong>13. </strong>
            <strong>Limitation of Liability</strong>
        </p>
        <p>
            a) We and our Creators will not be held responsible for any delay or
            failure to comply with our obligations under these conditions if the delay
            or failure arises from any cause which is beyond our reasonable control.
        </p>
        <p>
            b) In case you avail services while accessing the Platform, that is
            supported and/or provided by third party creator(s), for all such services
            your contracting entity will be such third-party creator(s), as the case
            may be. TravelQuest disclaims all liability for any claims that may arise
            pursuant to your use of services provided by such third-party creators.
        </p>
        <p>
            c) To the maximum extent permitted by law, in no event shall TravelQuest
            (or our licensors or affiliates) be liable to you or any third party for
            any damage, lost profits, lost data, costs of procurement of substitute
            services, or any indirect, consequential, exemplary, incidental, special or
            punitive damages arising from or relating to these terms or your use of, or
            inability to use or purchase from, the site, even if TravelQuest has been
            advised of the possibility of such damages. Access to, and use of, the Site
            is at your own discretion and risk, and you will be solely responsible for
            any damage to your device or computer system, electric vehicle or loss of
            data resulting therefrom.
        </p>
        <p>
            d) To the maximum extent permitted by law, notwithstanding anything to the
            contrary contained herein, our liability to you for any damages arising
            from or related to these Terms (for any cause whatsoever and regardless of
            the form of the action), will at all times be limited to amount of your
            ticket in question. The existence of more than one claim will not enlarge
            this limit.
        </p>
        <p>
            <strong>14. </strong>
            <strong>Indemnity</strong>
        </p>
        <p>
            You acknowledge to defend, indemnify and hold TravelQuest, its affiliates,
            subsidiaries, directors, officers, employees, agents, partners, and any
            other licensors (hereinafter referred to as    <strong> “Indemnified Party”</strong>) harmless from and against any claim,
            disputes, fine, liability, demand or expense, including reasonable
            attorneys’ fees, made by a third party, relating to, or arising from:    <strong></strong>
        </p>
        <p>
            a) Your violation of any third-party right, including without limitation to
            any right to privacy, publicity rights, defamation or intellectual property
            rights, including content the user distributes through the services;
        </p>
        <p>
            b) Your wrongful or improper use of services, Platform;
        </p>
        <p>
            c) You lack of caution and misguided judgment;
        </p>
        <p>
            d) Your violation of any applicable laws, rules or regulations or any other
            applicable law through or related to the use of our Services;
        </p>
        <p>
            e) Your violation of these Terms or any other policy of TravelQuest as
            associated with our services;
        </p>
        <p>
            f) The indemnifications set forth above will survive the termination or
            expiration of these Terms and/or your use of our services.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>15. </strong>
            <strong>Copyright Infringement </strong>
        </p>
        <p>
            a) If we are put on notice that your use, action, comment or feedback
            violates the law or the rights of others, or if we discover that your
            content or behaviour is unlawful, inappropriate, or objectionable    <em>(for example if you impersonate someone else or harass them)</em>, we
            may remove your feedback from our platform, and/or delete, suspend your
            account from Platform. <strong></strong>
        </p>
        <p>
            b) Please notify us if you believe any of your intellectual property rights
            have been infringed on our Platform. Please file your copyright
            infringement claim with our Copyright Agent, namely <strong>Dan,</strong>
            at <strong>dan@TravelAndQuest.com</strong> for such complaints and claims.    <strong></strong>
        </p>
        <p>
            c) You are required to follow the below procedure to file a claim:
        </p>
        <p>
            i. Identify in writing the copyrighted material that you claim has been
            infringed upon;
        </p>
        <p>
            ii. Identify in writing the copyrighted material that has infringed upon
            your copyright;
        </p>
        <p>
            iii. Provide your current and up-to-date contact information, including
            your address, telephone number, and e-mail address;
        </p>
        <p>
            iv. Provide your physical and/or electronic signature;
        </p>
        <p>
            v. Send us a written communication to    <strong>dan@TravelAndQuest.com.</strong>
        </p>
        <p>
            vi. You may be subject to liability if you knowingly make any
            misrepresentations on a take-down notice or claim.
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>16. </strong>
            <strong>Transaction and Disputes between you and Creators</strong>
        </p>
        <p>
            a) TravelQuest is merely a facilitator and is not and cannot be a party to
            or control in any manner any game, information, claim, or provision of
            service on the Platform.
        </p>
        <p>
            b) When a quest is listed on the Platform by a Creator, service availed by
            the user from the Creator will be governed by the bipartite contractual
            arrangement entered into directly between the user and the Creator. User
            agrees that TravelQuest cannot and does not confirm each Creator’s
            purported identity. TravelQuest encourages users to exercise discretion and
            caution while dealing with any Creator, on or off the Platform.
        </p>
        <p>
            c) For any Services, TravelQuest does not represent either the Creator or
            the buyer in specific transactions. TravelQuest does not control and is not
            liable to or responsible for the quality, safety, suitability of services,
            lawfulness or availability of the services or games offered for sale on or
            through the Platform. TravelQuest does not implicitly or explicitly support
            or endorse the sale or purchase of any service on the Platform. At no time
            shall any right, title or interest in the service sold through or displayed
            on the Platform vest with TravelQuest nor shall TravelQuest have any
            obligations or liabilities in respect of any transactions on or off the
            Platform.
        </p>
        <p>
            d) In the event that any user has a dispute with any party to a transaction
            such user agrees to release and indemnify TravelQuest (and our agents,
            affiliates, directors, officers and employees) from all claims, demands,
            actions, proceedings, costs, expenses and damages (including without
            limitation any actual, special, incidental or consequential damages)
            arising out of or in connection with such transaction.
        </p>
        <p>
            e) We do not make any representations pertaining to the information,
            content, services and user acknowledges that we are only acting as an
            intermediary between the user and the Creator. User hereby further agrees,
            acknowledges and confirms that we are not responsible in any way for the
            services availed or booked by the user from the Creator and it is
            explicitly agreed by the user that we will not in any way, under any
            circumstances whatsoever, be responsible or held liable for services
            availed by user from the Creator and/or in relation to any issue and/or
            dispute thereof.
            <strong>
                User hereby further agrees, acknowledges and confirms that under the
                aforesaid circumstances user’s only recourse will be against the
                Creator and we will not be made a party to any such issue and/or
                dispute between the Creator and the user.
            </strong>
        </p>
        <p>
            <strong>17. </strong>
            <strong>Governing Law and Dispute Resolution</strong>
        </p>
        <p>
            <strong> i. </strong>
            <strong>Governing Law: </strong>
            <a name="_Hlk69460853">
                The Terms and any dispute arising out of or relating to the same will
                be governed by applicable laws of the
            </a>
            <strong>State of Israel</strong>
            . <strong></strong>
        </p>
        <p>
            <strong> ii. </strong>
            <strong>Dispute Resolution:</strong>
        </p>
        <p>
            a) <strong>Amicable Resolution:</strong> If in case, any controversy,
            conflict or dispute of any nature arises between the user and TravelQuest,
            in connection with the provisions of these Terms, or our Privacy Policy, or
            out of or relating to or in connection with the use of our Website, the
            parties shall spend at least <strong>30 days</strong> to try and use all
            means to amicably resolve that dispute or conflict or controversy, with
            mutual discussions.
        </p>
        <p>
            b) <strong>Exclusive Jurisdiction: </strong>If however, the attempt to
            settle such a dispute amicably fail, then such controversy, conflict or
            dispute between the user and TravelQuest, shall be submitted to exclusive
            jurisdiction of the courts located within <strong>State of Israel.</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>18. </strong>
            <strong>Notices</strong>
        </p>
        <p>
            When you use the Website or send emails to TravelQuest, you are
            communicating with us electronically. You consent to receive electronically
            any communications related to your use of this Website.
            <em>
                <u>
                    TravelQuest will communicate with you by email, SMS, WhatsApp,
                    phone call or by posting notices on this Website
                </u>
            </em>
            . You agree that all agreements, notices, disclosures and other
            communications that are provided to you electronically satisfy any legal
            requirement that such communications be in writing. We may give notice by
            means of a general notice via electronic mail to your email address as
            available with us. If you want to give a notice to us, you can do so by
            dropping an electronic mail to <strong>dan@TravelAndQuest.com</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>19. </strong>
            <strong>Miscellaneous</strong>
        </p>
        <p>
            i. <strong>Severability:</strong> If any provision of these Terms is held
            to be unenforceable or invalid, such provision will be changed and
            interpreted to accomplish the objectives of such provision to the greatest
            extent possible under applicable law and the remaining provisions of these
            Terms will continue in full force and effect.
        </p>
        <p>
            ii. <strong>Waiver:</strong> Our failure to insist on or enforce strict
            performance of these Terms of Use shall not be construed as a waiver by us
            of any provision or any right that we have to enforce these Terms and nor
            shall any course of conduct between TravelQuest and you or any other party
            be deemed to modify any provision of these Terms.
        </p>
        <p>
            iii. <strong>Survival: </strong>Notwithstanding any other provisions of
            these Terms of Use, or any general legal principles to the contrary, any
            provision of these Terms of Use that imposes or contemplates continuing
            obligations on either party shall survive the expiration or termination of
            these Terms of Use, for any reason whatsoever.
        </p>
        <p>
            iv. <strong>No Third-Party Beneficiaries: </strong>Except as otherwise
            expressly provided in these Terms of Use or the Purchase, Return and Refund
            Policy, there shall be no third-party beneficiaries to these Terms of Use
            or the Purchase, Return and Refund Policy.
        </p>
        <p>
            v. <strong>No Assignment: </strong>You may not assign these Terms of Use
            (or any rights, benefits or obligations hereunder) by operation of law or
            otherwise without the prior written consent of TravelQuest, which may be
            withheld at TravelQuest’s sole discretion. Any attempted assignment that
            does not comply with these Terms of Use, shall be null and void.
        </p>
        <p>
            vi. <strong>Entire Agreement:</strong> The Terms, Disclaimer, Privacy
            Policy, Cookie Policy, Creator Terms <em>(if applicable to you), </em>
            together with any additional terms and conditions incorporated herein or
            referred to herein constitute the entire Agreement between TravelQuest and
            you, relating to the subject matter hereof, and supersedes any prior
            understanding or agreements (whether oral or written) regarding the subject
            matter, and may not be amended or modified except in writing or by making
            such amendments or modifications available on our Platform.
        </p>
        <p>
            vii. <strong>Force Majeure:</strong> TravelQuest, its associates and its
            Creators will be excused from performance for any period during which, and
            to the extent that, such party or any subcontractor is prevented from
            performing any obligation or service (such as processing or shipment or
            delivery of your order), in whole or in part, as a result of causes beyond
            its reasonable control, and without its fault or negligence, including
            without limitation, acts of God, strikes, lockouts, riots, acts of
            terrorism or war, epidemics, communication line failures, power failures
            and government-imposed lockdowns or similar restrictions.
        </p>
        <p>
            viii. <strong>Updates to these Terms: </strong>We may add to or change or
            update these Terms at any time, from time to time, entirely at our own
            discretion, with or without any prior written notice. You are responsible
            for checking these Terms periodically. Your use of the Site after any
            amendments to the Terms shall constitute your acceptance to such
            amendments.
        </p>
        <p>
            <strong>20. </strong>
            <strong>Grievance Officer</strong>
        </p>
        <p>
            In the event you have any grievance regarding anything related to these    <strong>Terms, Disclaimer</strong> or our <strong>Privacy Policy</strong>
            statement, or with any content or service of TravelQuest, in that case you
            may freely write your concerns to the Grievance Officer to:-
        </p>
        <p>
            Name: Dan
        </p>
        <p>
            Contact: +972 504092457
        </p>
        <p>
            Email: <strong>dan@TravelAndQuest.com</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>21. </strong>
            <strong>Feedback and Information</strong>
        </p>
        <p>
            We welcome your questions or comments regarding the Terms. You can write to
            us via email: <strong>dan@TravelAndQuest.com</strong><strong></strong>
        </p>
        <p>
            Last updated on<strong> 29.12.2021</strong>
        </p>
    </div>
</template>

<script>
export default {
    name: "v_Terms_TermsOfUse"
}
</script>

<style scoped lang="scss">
p{
    margin: 16px;
}
</style>